import downArrow from "./images/downArrow.svg";
import downChevron from "./images/downChevron.svg";
import logo from "./images/logo.svg";
import headerlogo from "./images/headerlogo.svg";
import noRecord from "./images/NoRecord.svg";
import datePicker from "./images/datePicker.svg";
import otis_logo from "./images/Otis_logo.svg";
import successIcon from "./images/successIcon.svg";
import homeIcon from "./images/homeIcon.svg";
import userIcon from "./images/userSettings.svg";
import reportIcon from "./images/reportIcon.svg";
import auditIcon from "./images/auditIcon.svg";

class Assets {
    static downArrow = downArrow;
    static downChevron = downChevron;
    static userIcon = userIcon;
    static reportIcon = reportIcon;
    static auditIcon = auditIcon;
    static logo = logo;
    static headerlogo = headerlogo;
    static noRecord = noRecord;
    static datePicker = datePicker;
    static otis_logo = otis_logo;
    static successIcon = successIcon;
    static homeIcon = homeIcon;
}

export default Assets;